import {DEFAULT_TIME_ZONE} from 'src/internal/constants';

const browserTimeZone: string = DEFAULT_TIME_ZONE;

/**
 * A string representing the runtime's default time zone.
 *
 * The source for time zone names is the [IANA time zone database](https://www.iana.org/time-zones).
 *
 * @see https://sail.stripe.me/apis/intl/browserTimeZone
 */
export default browserTimeZone;
